import { render, staticRenderFns } from "./listaMoeda.vue?vue&type=template&id=8466c25c&scoped=true&"
import script from "./listaMoeda.vue?vue&type=script&lang=js&"
export * from "./listaMoeda.vue?vue&type=script&lang=js&"
import style0 from "./listaMoeda.vue?vue&type=style&index=0&id=8466c25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8466c25c",
  null
  
)

export default component.exports